// src/store/rootReducer.ts
import { combineReducers } from '@reduxjs/toolkit';
import accountReducer from '../Account/Presentation/reducers';
import slotReducer from '../Slot/Presentation/reducers';
import logReducer from '../Log/Presentation/reducers';
import noticeReducer from '../Notice/Presentation/reducers';
import authReducer, { logout } from '../User/Presentation/reducers';
import keywordReducer from '../Keyword/Presentation/reducers';
import urlRankReducer from '../UrlRank/Presentation/reducers';

const appReducer = combineReducers({
  account: accountReducer,
  slot: slotReducer,
  log: logReducer,
  notice: noticeReducer,
  auth: authReducer,
  keyword: keywordReducer,
  urlRank: urlRankReducer,
});

const rootReducer = (state: ReturnType<typeof appReducer> | undefined, action: any) => {
  if (action.type === logout.type) {
    // 모든 slice 초기화
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
